<template>
  <div id="participant-addupdate-addsubevents-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />

    <div class="modal-body" v-else key="content-loading">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="registerform-input-container">
            <div class="title">
              <label>{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.additionalProduct") }}</label>
              <!-- <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip> -->
            </div>
            <el-select v-model="form.additionalProductId" clearable @clear="form.additionalProductId = null">
              <el-option v-for="subevent in $store.state.additionalProducts.items" :key="subevent.id" :disabled="selectedSubEvents.some(x => x.additionalProductId == subevent.id)" :label="subevent.title" :value="subevent.id"></el-option>
            </el-select>
          </div>
        </el-col>
 
      </el-row>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.close") }}</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')" v-if="form.id">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.delete") }}</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save" v-if="form.additionalProductId">{{ $t("participantManagament.attendeeList.participant.addUpdateParticipant.addDialogs.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "activeSubIndex", "selectedSubEvents"],
  data() {
    return {
      form: {
        id: null,
        additionalProductId: null,
        status: 0,
      },
      timeout: null,
      loading: false,
    };
  },
  methods: {
    deleteItem(){
      this.$emit('closeDialog');
      this.$emit('deleteProduct')
    },
    save() {
      var payload = {
        ...this.form,
        questions: this.availableQuestions
      };
      console.log("payload", payload);
      this.$emit("addUpdate", payload);
    }
  },
  created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
      this.loading = false;
    }, 500);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/participants/dialog/AddAdditionalProduct.vue